import React from "react";
import {
  question_type_id,
  questions_type_mapping,
} from "constants/customerQuestions.constants";

export const QUESTION_FORM_KEYS = {
  question: {
    label: "Question",
    labelKey: "question",
    key: "questionObj.question",
    placeholder: "Enter Question",
  },
  type: {
    labelKey: "type",
    label: "Answer Type",
    key: "questionObj.type",
  },
  question_placement: {
    labelKey: "question_placement",
    label: "Question Placement",
    key: "questionObj.question_placement",
  },
  is_mandatory: {
    key: "questionObj.is_mandatory",
  },
  enable_otp_verification: {
    key: "questionObj.enable_otp_verification",
  },
  multi_questions: {
    key: "questionObj.multi_questions",
  },
};

export const TOOL_TIP_MANDATORY_TITLE = (
  <div>
    <div>
      Mandatory questions are <strong>‘necessary-to-answer’</strong> and the
      student will be required to answer this question to proceed.
    </div>
    <div>Turn the toggle on if you want to make it mandatory.</div>
  </div>
);

export const TOOL_TIP_MANDATORY_PHONE_NUMBER = (
  <div>
    <div>
      When enabled, phone number verification becomes <strong>mandatory</strong>
      . The user must verify their phone number using an OTP to proceed.
    </div>
    <div>
      Turn this toggle on if you want to ensure only verified phone numbers are
      accepted.
    </div>
  </div>
);

export const QUESTION_TYPE_IDS = {
  ...question_type_id,
  EMAIL: 15,
  PHONE_NUMBER: 16,
};

export const EXTRA_DEFAULT_QUESTION_OPTIONS = {
  [QUESTION_TYPE_IDS.EMAIL]: {
    id: 12,
    value: 15,
    label: "Email",
  },
  [QUESTION_TYPE_IDS.PHONE_NUMBER]: {
    id: 13,
    value: 16,
    label: "Phone Number",
  },
};

export const QUESTION_TYPE_MAPPING = {
  ...questions_type_mapping,
  ...EXTRA_DEFAULT_QUESTION_OPTIONS,
};

export const renderTypeSpecificValidation = (question) => {
  if (
    question?.type &&
    questions_type_mapping[question?.type]?.typeSpecificValidation
  ) {
    return questions_type_mapping[question?.type]?.typeSpecificValidation(
      question
    );
  }
  return null;
};

export const questionOptions = [
  {
    supportedQuestionTypes: [QUESTION_TYPE_IDS.PHONE_NUMBER],
    label: "Verify number via OTP",
    formKey: QUESTION_FORM_KEYS.enable_otp_verification.key,
    disabled: false,
    tooltipJSX: (
      <div>
        <div>
          Enable this option to verify the student’s phone number using an{" "}
          <strong>OTP</strong>.
        </div>
        <div>
          The student will receive an OTP on their phone and must enter it to
          confirm their number.
        </div>
      </div>
    ),
  },
  {
    supportedQuestionTypes: Object.keys(QUESTION_TYPE_IDS).map(
      (key) => QUESTION_TYPE_IDS[key]
    ),
    label: "This is a mandatory question",
    formKey: QUESTION_FORM_KEYS.is_mandatory.key,
    tooltipJSX: (
      <div>
        <div>
          Mandatory questions are <strong>‘necessary-to-answer’</strong> and the
          student will be required to answer this question to proceed.
        </div>
        <div>Turn the toggle on if you want to make it mandatory.</div>
      </div>
    ),
  },
];
